//importing from firebase.js file
// FIREBASE DISABLED - Commented out imports
// import analytics from "./firebase";
// import { logEvent } from "firebase/analytics";
import breakpoints from "./assets/theme/base/breakpoints";

export const getPlatform = () => {
  if (window.navigator && window.navigator.userAgent.includes("Electron")) {
    return "ElectronApp"; // Detects Electron
  }

  if (window.innerWidth < breakpoints.values.sm) {
    return "MPOS"; // Mobile Point of Sale
  }

  return "WebPOS"; // Default is Web Point of Sale
};

//Custom functions for all events
// FIREBASE DISABLED - No-op function
export const customEventTrigger = (eventName, payload = {}) => {
  // Firebase is disabled - do nothing
  // try {
  //   if (process.env.MY_ENV !== "production") return;
  //   payload.page_title = `pos_${window.location.pathname}`; // add pathname to the payload
  //   payload.platform = getPlatform();
  //   logEvent(analytics, eventName, payload);
  // } catch (err) {
  //   console.log("error from analytics page", err);
  // }
};
